import _defineProperty from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _this = this;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _ from 'lodash';
import flow from 'lodash/fp/flow';
import keys from 'lodash/fp/keys';
import reject from 'lodash/fp/reject';
import { categories } from 'shared/constants';
import { getIntegrationCategory } from 'shared/core/helpers/integrations';
import { integrationsByCategory } from 'shared/core/constants/integrations';
export var flattenedIntegrationsForSegment = function flattenedIntegrationsForSegment() {
  var result = {};
  _.forEach(_.values(integrationsByCategory), function (categoryIntegrations) {
    var childKeys = _.keys(categoryIntegrations);
    _.forEach(childKeys, function (k) {
      result[k] = false;
    });
  });
  return result;
};
export var highSpeedIntegrations = ['flowhub', 'greenbitsV2', 'treezV2', 'anthea'];
export var highSpeedIntegrationTime = '5 minutes';
var restrictedIntegrations = {
  chase: function chase(_ref) {
    var showChaseFeature = _ref.showChaseFeature;
    return showChaseFeature;
  },
  dutchiePay: function dutchiePay(_ref2) {
    var showDutchiePay = _ref2.showDutchiePay;
    return showDutchiePay;
  },
  fyllo: function fyllo(_ref3) {
    var showFylloFeature = _ref3.showFylloFeature;
    return showFylloFeature;
  },
  menuImport: function menuImport(_ref4) {
    var _dispensary$featureFl;
    var dispensary = _ref4.dispensary;
    return dispensary === null || dispensary === void 0 || (_dispensary$featureFl = dispensary.featureFlags) === null || _dispensary$featureFl === void 0 ? void 0 : _dispensary$featureFl.enableMenuImport;
  },
  naturesMedicine: function naturesMedicine(_ref5) {
    var dispensary = _ref5.dispensary;
    return dispensary.chain === 'natures-medicines';
  },
  sndl: function sndl(_ref6) {
    var dispensary = _ref6.dispensary;
    return ['spiritleaf', 'superette'].includes(dispensary.chain);
  }
};
export var integrationWholesaleSupport = {
  blaze: true,
  flowhub: true,
  treezV2: true
};
export var availableIntegrations = function availableIntegrations(_ref7) {
  var dispensary = _ref7.dispensary,
    showChaseFeature = _ref7.showChaseFeature,
    showFylloFeature = _ref7.showFylloFeature;
  var names = {};
  _.forIn(integrationsByCategory, function (value) {
    return names = _objectSpread(_objectSpread({}, names), value);
  });
  return flow(keys, reject(function (adapter) {
    return restrictedIntegrations[adapter] && !restrictedIntegrations[adapter].call(_this, {
      dispensary: dispensary,
      showChaseFeature: showChaseFeature,
      showFylloFeature: showFylloFeature
    });
  }))(names);
};
export var integrationDisplayName = function integrationDisplayName(adapter) {
  var names = {};
  _.forIn(integrationsByCategory, function (value) {
    return names = _objectSpread(_objectSpread({}, names), value);
  });
  return names[adapter] || adapter;
};
export var integrationCategoryDisplay = function integrationCategoryDisplay(adapter) {
  var category = getIntegrationCategory(adapter);
  var names = {
    pos: 'Point of Sale',
    fleetManagement: 'Fleet Management',
    crm: 'CRM',
    analytics: 'Analytics',
    rewards: 'Loyalty & Rewards',
    payments: 'Payments',
    menuImport: 'Menu Import'
  };
  return names[category] || 'Point of Sale';
};
function getRewardDescription(adapter, name) {
  switch (adapter) {
    case 'springbig':
      return "Allow customers to use their Springbig Rewards or Springbig Offers rewards on a Dutchie order.";
    case 'dutchieposloyalty':
      return "Dutchie Point of Sale must be enabled to use Dutchie POS Loyalty.";
    default:
      return "Allow customers to use their ".concat(name, " rewards on a Dutchie order.");
  }
}
export var integrationDescription = function integrationDescription(adapter, shouldShowUpdatedHubspotText) {
  var name = integrationDisplayName(adapter);
  var category = getIntegrationCategory(adapter);
  var hubspotCopy = shouldShowUpdatedHubspotText ? "Record Deals, Contacts, and Line Items in HubSpot for each Dutchie order or cart created." : "Record Deals, Contacts, and Line Items in HubSpot for each Dutchie order placed.";
  var descriptions = {
    fleetManagement: "Send Dutchie orders directly to ".concat(name, " to manage drivers and optimize routes."),
    crm: adapter === 'hubspot' ? hubspotCopy : "Send your customer information directly to ".concat(name, "."),
    analytics: "Send sales data from your embedded menu into ".concat(name, " to track helpful information\n    such as product performance, shopping cart funnels, and more."),
    rewards: getRewardDescription(adapter, name),
    payments: adapter === 'hypur' ? "Connect your Dutchie account with Hypur\n      so your customers can use Hypur's online payment solution when they checkout." : "Connect to your ".concat(name, " account to accept credit\n      card payments on Dutchie orders. Once enabled, customers can pay for their\n      order with any major credit card and funds will be automatically deposited into your ").concat(name, " account."),
    menuImport: // As items are bought through Dutchie, they’ll automatically deduct from the current inventory count of that
    // product.', leaving this one out for now; replace when implemented
    "Manually import your inventory as a .CSV File and we\u2019ll instantly build your menu.\n      You can import your menu as often as you like to keep your inventory up to date.",
    "default": "Connect your Dutchie menu with your ".concat(name, " inventory, so new and sold out items sync in real-time.")
  };
  /* eslint-enable */

  return descriptions[category] || descriptions["default"];
};
export var integrationCardDescription = function integrationCardDescription(adapter) {
  var name = integrationDisplayName(adapter);
  var descriptions = {
    merrco: "Connect to your ".concat(name, " account to accept credit card payments on Dutchie orders."),
    hypur: "Connect your Dutchie account with Hypur so your customers can use Hypur's\n    online payment solution when they checkout."
  };
  return descriptions[adapter];
};
export var integrationSyncTime = function integrationSyncTime(adapter) {
  return highSpeedIntegrations.includes(adapter) ? highSpeedIntegrationTime : '10 minutes';
};
export var imageStyle = function imageStyle(adapter) {
  if (adapter === 'onfleet') {
    return {
      paddingBottom: '18px',
      height: '40px'
    };
  }
  if (adapter === 'merrco') {
    return {
      paddingBottom: '10px',
      height: '35px'
    };
  }
  if (adapter === 'menuImport') {
    return {
      paddingBottom: '10px',
      height: '58px'
    };
  }
  return {
    paddingBottom: '10px',
    height: '48px'
  };
};
export var imageUrl = function imageUrl(adapter) {
  var nonStandardImageUrls = {
    cannveya: '/images/cannveya-logo.svg',
    'google-tag-manager': '/images/google-tag-manager-logo.svg',
    fyllo: '/images/fyllo-logo.png',
    hypur: '/images/hypur-logo.svg',
    menuImport: '/images/menu-import.svg',
    merrco: '/images/merrco-logo.svg',
    pineappleExpress: '/images/pineapple-express-logo.png',
    shopify: '/images/shopify-logo.svg'
  };
  return _.get(nonStandardImageUrls, adapter, "/images/".concat(adapter, "-logo.png"));
};
export var shouldIncludeIntegrationNameWithImage = function shouldIncludeIntegrationNameWithImage(adapter) {
  return ['menuImport'].includes(adapter);
};
export var canAddNewIntegration = function canAddNewIntegration(category) {
  var existingCategories = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (category === 'analytics') {
    return true;
  }
  if (existingCategories.includes('pos')) {
    existingCategories.push('menuImport');
  }
  if (existingCategories.includes('menuImport')) {
    existingCategories.push('pos');
  }
  return !_.includes(existingCategories, category);
};

// Used to get the categories that are coming from an integration object.
// Looks at legacy and new data types.
export var categoriesInUse = function categoriesInUse(integration) {
  var _integration$category;
  if (!integration) {
    return [];
  }
  var mappedCategories = [];
  if ((_integration$category = integration.categoryMapping) !== null && _integration$category !== void 0 && _integration$category.length) {
    mappedCategories = _.map(integration.categoryMapping, 'localCategory');
  }
  if (!mappedCategories.length && integration.types) {
    mappedCategories = _.values(integration.types);
  }
  return categories.filter(function (category) {
    return category !== 'N/A' && mappedCategories.includes(category);
  });
};
export var getFilteredIntegration = function getFilteredIntegration(integrations, menuType) {
  var category = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'pos';
  var filteredIntegrations = _.filter(integrations, function (integration) {
    return getIntegrationCategory(integration.adapter) === category;
  });
  return _.find(filteredIntegrations, {
    integrationType: menuType
  }) || filteredIntegrations[0];
};